export class BuscarSedeDto {
    idSede: number;
    nombreSede: string;
    nombreCiudad: string;
    estado: boolean;
    companias: string;
    idCompanias: number[];
}



// WEBPACK FOOTER //
// ./src/app/shared/models/buscar-sede-dto.ts